export function htmlEscape(href : string ) {
    return href.replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/\//g, '%2f');
}

export function swichCase<TItem, TResult>(item: TItem, ...conditions:
    ({
        when?: ((item: TItem) => boolean),
        then?: ((item: TItem) => TResult)
        otherwise?: ((item: TItem) => TResult)
    })[]
    ): TResult {
        var otherwise = conditions.find(c => c.otherwise !== undefined);
        var cases = conditions.filter(c => c.when !== undefined && c.then !== undefined);
        for (var c of cases) {
            if (c.when(item)) {
                return c.then(item);
            }
    }
    return otherwise.otherwise(item);
}

export function isJSON (data: any): boolean {
    try {
        var o = JSON.parse(data);
        if (o && typeof o === "object") return true;        
    }
    catch (e) { }
    return false;
};
 